export default __webpack_public_path__ + "static/media/welcome2.df7da232.png";